import { ImageMedia } from "../../../../../features/media/domain/models/media";
import { CustomTags } from "../../../../../shared/entities/custom-tags";
import { Platform } from "../../../../../shared/enums/campaignPost.enums";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";
import {
  IPublicationTemplate,
  RecommendedSchedule,
} from "./publication-template";

export enum LinkType {
  CampaignUrl = "CAMPAIGN_URL",
  PublisherUrl = "PARTNER_URL",
  CustomUrl = "SPECIFIC_URL",
}

export const getLinkTypeFromLink = (link?: string): LinkType =>
  link === CustomTags.CampaignUrl
    ? LinkType.CampaignUrl
    : link === CustomTags.PublisherUrl
      ? LinkType.PublisherUrl
      : LinkType.CustomUrl;

export class FacebookCarouselSlide {
  constructor(
    public readonly media: ImageMedia,
    public readonly title: string,
    public readonly linkType: LinkType,
    public readonly link?: string,
    public readonly description?: string,
  ) {}
}

export class FacebookCarousel implements IPublicationTemplate {
  public readonly type = PublicationTemplateType.FacebookCarousel;
  public readonly platform = Platform.Facebook;
  public readonly isAd = false;

  constructor(
    public readonly id: string,
    public readonly slides: FacebookCarouselSlide[],
    public readonly text: string,
    public readonly link: string,
    public readonly recommendedSchedules: RecommendedSchedule[],
  ) {}
}
